import { render, staticRenderFns } from "./contact-preferences-table.vue?vue&type=template&id=3914e880&"
import script from "./contact-preferences-table.vue?vue&type=script&lang=js&"
export * from "./contact-preferences-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports